import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (admin) return <Navigate to="/admin/bookings" replace/>;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Welcome back"); nav("/admin/bookings"); }
    catch { toast.error("Invalid credentials"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex">
      <div className="hidden md:block flex-1 bg-[#0F172A] text-[#FFFFFF] relative overflow-hidden">
        <div className="absolute inset-0 grain"/>
        <div className="relative z-10 h-full flex flex-col justify-between p-16">
          <div className="font-serif-display text-3xl">Hedieh's</div>
          <div>
            <div className="overline text-[#D4AF37]">Staff Portal</div>
            <h1 className="font-serif-display text-6xl mt-4 leading-none">Behind every<br/>perfect fit.</h1>
          </div>
          <div className="text-xs text-[#F8FAFC]/40">© Hedieh's Alterations · Rhodes NSW</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="overline">Staff Login</div>
          <h2 className="font-serif-display text-4xl mt-3 mb-10">Welcome back.</h2>
          <label className="overline">Email</label>
          <input data-testid={ADMIN.loginEmail} type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
          <label className="overline mt-6 block">Password</label>
          <input data-testid={ADMIN.loginPassword} type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                 className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
          <button data-testid={ADMIN.loginSubmit} type="submit" disabled={loading}
                  className="mt-10 w-full py-4 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F] disabled:opacity-30">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
